module.exports = __webpack_public_path__ + "img/brands-q8.7faf13ec.svg";